const magazineGenerateTableOfContent = () => {
    const tableOfContent = document.querySelector('.jsMagazineGenerateTableOfContent');

    if(!tableOfContent) return;

    const titles = [...document.querySelector('.p-magazine-single-content').querySelectorAll('h2')];

    const generateTableContentLink = (titleValue, titleIdValue) => {
        const element = `
            <div>
                <a href="#${titleIdValue}" data-short-code>
                    <i class="p-magazine-single-tableofcontent-icon"></i>

                    <span class="p-magazine-single-tableofcontent-text">
                        ${titleValue}
                    </span>
                </a>
            </div>
        `
        tableOfContent.insertAdjacentHTML('beforeend', element);
    }
    const setTitleIdValue = () => {
        titles.forEach((title, index) => {
            const titleIdValue = `page-scroll-title-${index}`;

            title.setAttribute('id', titleIdValue);
            generateTableContentLink(title.textContent, titleIdValue);
        });
    }

    window.addEventListener('load', setTitleIdValue);
}

export { magazineGenerateTableOfContent };
